import React, { useState } from "react";

import FilterIcon from "pages/[tenant]/search/assets/FilterIcon";
import { useNewGlobalSearch } from "pages/[tenant]/search/hooks/useNewGlobalSearch";

import { FilterButton, SearchFiltersContainer } from "./styles";

const SearchFilters = () => {
  const { handleChangeModal } = useNewGlobalSearch();
  return (
    <SearchFiltersContainer>
      <FilterButton onClick={() => handleChangeModal()}>
        <FilterIcon />
        Filtros
      </FilterButton>
    </SearchFiltersContainer>
  );
};

export default SearchFilters;
